module.exports = __webpack_public_path__ + "static/J2025_SNCS_abs-3ca98d20f305d926aaa8c0718c751fbf.png";